import imagesLoaded from 'imagesloaded'

// Once the image has finished loading it will fade it
// Offers more graceful image loading
// should be used in conjunction with placeholder or background
export default {
  bind (el) {
    el.style.opacity = 0
    el.style.transition = 'opacity 1s'
    // imagesLoaded(el, { background: true }, () => {
    //   el.style.opacity = 1
    // })
    const imgLoad = imagesLoaded(el)
    imgLoad.on('fail', instance => {
      const spinner = el.parentElement.querySelector('[data-spinner]')
      console.error('Image missing for:', el)
      if (spinner) {
        spinner.style.transition = 'opacity 300ms'
        spinner.style.background = 'none'
        spinner.style.opacity = 0
      }
    })
    imgLoad.on('done', instance => {
      const spinner = el.parentElement.querySelector('[data-spinner]')
      if (spinner) {
        spinner.style.transition = 'opacity 300ms'
        spinner.style.background = 'none'
        spinner.style.opacity = 0
      }
      el.style.opacity = 1
    })
    
  }
}



// WEBPACK FOOTER //
// ./src/vue-directives/imagesLoaded.js